import axios from 'axios';
import { BACK_API_URL } from '../constants/constants';
import { Employee } from '../interfaces/Employee';
import { Transaction } from '../interfaces/Transaction';
import { SignatureHeaders } from './signRequest';

/**
 * Единственная граница с бэком. Пишущие запросы несут подпись админа.
 * Ошибка превращается в текст для оператора, техническая подробность — в
 * консоль.
 */

const STATUS_MESSAGES: Record<number, string> = {
  400: 'Бэк отклонил данные',
  401: 'Подпись не принята — повторите операцию',
  403: 'Этот кошелёк не может менять данные панели',
  404: 'Сотрудник не найден в базе',
  409: 'Такая запись уже есть в базе',
};

export function apiErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error) && error.response) {
    const status = error.response.status;
    const detail = (error.response.data as { message?: string })?.message;
    const base = STATUS_MESSAGES[status] ?? `Ошибка бэка (${status})`;
    return detail && status === 400 ? `${base}: ${detail}` : base;
  }

  return 'Бэк недоступен — проверьте соединение';
}

const url = (path: string) => `${BACK_API_URL}${path}`;

export const fetchEmployees = async (): Promise<Employee[]> =>
  (await axios.get(url('/employees'))).data;

export const fetchTransactions = async (): Promise<Transaction[]> =>
  (await axios.get(url('/transactions'))).data;

export const createEmployee = (
  body: { full_name: string; wallet_address: string; salary: string },
  headers: SignatureHeaders,
) => axios.post(url('/employees'), body, { headers });

export type EditableField = 'salary' | 'bonus' | 'penalty';

export const updateEmployeeField = (
  wallet: string,
  field: EditableField,
  value: string,
  headers: SignatureHeaders,
) =>
  axios.put(
    url(`/employees/${field}`),
    { wallet_address: wallet, [field]: value },
    { headers },
  );

export const deleteEmployee = (wallet: string, headers: SignatureHeaders) =>
  axios.delete(url(`/employees/${wallet}`), { headers });

export const recordPayout = (
  body: { date: string; amount: string; hash: string },
  headers: SignatureHeaders,
) => axios.post(url('/transactions'), body, { headers });
